// Shared error type for the public, token-gated portals (candidate Portal and
// SetupPortal). Both hit unauthenticated endpoints where the token itself can
// be invalid, expired, or revoked (typically surfaced as 404/410/4xx), so
// query retry logic needs the HTTP status to decide whether a retry could
// ever succeed.
export class PortalRequestError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'PortalRequestError';
    this.status = status;
    // Restore the prototype chain broken by ES5 class-extends-Error
    // downleveling so `instanceof PortalRequestError` works (same fix as
    // OfferContractError and friends).
    Object.setPrototypeOf(this, PortalRequestError.prototype);
  }
}

// 4xx (including 410 Gone) means the token/resource is invalid, expired, or
// revoked - retrying with the same request cannot change that. Anything else
// (network errors, 5xx) is worth a couple of retries.
export function isRetryablePortalError(error: unknown): boolean {
  if (!(error instanceof PortalRequestError)) return true;
  return error.status < 400 || error.status >= 500;
}
